import Axios, { AxiosInstance, InternalAxiosRequestConfig } from "axios";

import { authApi } from "./auth/authApi";

const LEGACY_API_VERSION = "v1.6.0";
export const API_GATEWAY_VERSION = "v1.1.0";

export const getApiUrl = (): string =>
  `${import.meta.env.VITE_API_LEGACY_URL}${LEGACY_API_VERSION}/`;

export const addAuthorizationToRequest = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const userToken = await authApi.getUserToken();
  config.headers.set("Authorization", `Bearer ${userToken}`);
  return config;
};

const LegacyApiClient = (): AxiosInstance => {
  const instance = Axios.create({
    baseURL: getApiUrl(),
  });

  instance.interceptors.request.use(addAuthorizationToRequest);
  return instance;
};

export const legacyApiClient = LegacyApiClient();

export const ApiGatewayClient = (params?: { Authorization: string }) => {
  const gatewayUrl = import.meta.env.VITE_API_GATEWAY_URL;
  const instance = Axios.create({
    baseURL: gatewayUrl,
  });

  if (params?.Authorization) {
    instance.defaults.headers.common.Authorization = params.Authorization;
  } else {
    instance.interceptors.request.use(addAuthorizationToRequest);
  }
  return instance;
};

export const apiGatewayClient = ApiGatewayClient();

export default {
  legacy: legacyApiClient,
  gateway: apiGatewayClient,
};
